import { createContext, useContext } from 'react';
import { BitcoinTransaction } from './types';

interface TxContextValue {
  transaction: BitcoinTransaction;
}

export const TxContext = createContext<TxContextValue | undefined>(undefined);

export const useTxContext = () => {
  const ctx = useContext(TxContext);
  if (!ctx) throw new Error('Must be used inside TxProvider');
  return ctx;
};
